import GAIATileDetailsModal from "@gaiaProfessionals/Widgets/HCP/GAIATileDetailsModal";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const {
        fields: { links = [] },
    } = ownProps;
    const location = getLocation(state);
    const parsedQuery = parseQueryString<{ step?: string }>(location.search);
    const step = parsedQuery.step ? parseInt(parsedQuery.step, 10) : -1;
    let currentStepData: LinkModel | null = null;
    if (step > 0 && step <= links.length) {
        currentStepData = links[step - 1];
    }

    return {
        location,
        parsedQuery,
        currentStepData,
    };
};

const enum fields {
    links = "links",
}

interface LinkModel {
    fields: {
        title: string;
        imageUrl: string;
        altText: string;
        description: string;
        summary: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: { [fields.links]: LinkModel[] };
}
type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasHistory;

export interface GaiaListingTileStyles {
    gaiaListingContainer?: InjectableCss;
    cardMainContainer?: InjectableCss;
    cardMainWrapper?: LinkProps;
    cardTileImage?: InjectableCss;
    cardContentWrapper?: InjectableCss;
    cardTitle?: TypographyProps;
    cardDescription?: TypographyProps;
    cardLink?: LinkProps;
    image?: LazyImageProps;
    img?: ImgProps;
    cardModal?: ModalPresentationProps;
    modalWrapper?: InjectableCss;
    modalImage?: InjectableCss;
    cardSummary?: InjectableCss;
}

export const gaiaListingTileStyles: GaiaListingTileStyles = {
    gaiaListingContainer: {
        css: css`
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            margin-top: 40px;
        `,
    },
    cardMainContainer: {
        css: css`
            margin-bottom: 15px;
            max-width: 23.9%;
            width: 24.5%;
            background-color: #f9f7f5;
            border-radius: 10px;
            margin-right: 15px;
            display: flex;
            position: relative;
            align-items: stretch;
            &:last-child {
                margin-right: 0px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                        margin-right: 0;
                        width: 100%;
                    `,
                    css`
                        max-width: 100%;
                        margin-right: 0;
                        width: 100%;
                    `,
                    css`
                        max-width: 48.6%;
                        margin-right: 20px;
                        width: 49%;
                        &:nth-child(2n) {
                            margin-right: 0;
                        }
                    `,
                    css`
                        max-width: 31.7%;
                        width: 31.7%;
                    `,
                    css`
                        max-width: 23.6%;
                        width: 24.5%;
                    `,
                ])}
        `,
    },
    cardMainWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            border: 1px solid #e5e5e5;
            border-radius: 6px;
            margin-bottom: 0px;
            margin-right: 0px;
            width: 100%;
            > span {
                width: 100%;
            }
        `,
    },
    cardTileImage: {
        css: css`
            height: 211px;
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: 230px;
                    `,
                    css`
                        height: 230px;
                    `,
                    css`
                        height: 300px;
                    `,
                    css``,
                    css``,
                ])};
        `,
    },
    img: {
        css: css`
            max-width: 100%;
            height: 100%;
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: 100%;
                    `,
                    css`
                        height: 100%;
                    `,
                    css``,
                    css``,
                    css``,
                ])};
            object-fit: cover;
        `,
    },
    cardModal: {
        size: 1188,
        cssOverrides: {
            modalTitle: css`
                padding: 13px 12px 13px 20px;
                border-bottom: 1px solid #e5e5e5;
                > h4 {
                    font-size: 22px;
                    color: #205c40;
                }
                > button {
                    border: 2px solid #333333;
                    border-radius: 50%;
                    width: 25px;
                    min-height: 25px;
                    height: 25px;
                    > span {
                        top: -5px !important;
                        left: -3px;
                        width: 20px;
                    }
                }
            `,
            modalContent: css`
                padding: 28px 45px 45px;
            `,
            modalBody: css`
                max-height: calc(100% - 40px);
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            max-height: 100%;
                        `,
                        css`
                            max-height: 100%;
                        `,
                        css`
                            max-height: 100%;
                        `,
                        css``,
                        css``,
                    ])}
            `,
        },
    },
    cardContentWrapper: {
        css: css`
            padding: 15px 18px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 15px 18px 30px;
                    `,
                    css`
                        padding: 15px 18px 30px;
                    `,
                    css`
                        min-height: 206px;
                        position: relative;
                    `,
                    css`
                        min-height: 206px;
                        position: relative;
                    `,
                    css`
                        min-height: 206px;
                        position: relative;
                    `,
                ])}
        `,
    },
    cardTitle: {
        variant: "h2",
        color: "primary",
        css: css`
            font-size: 1.375rem;
            margin-bottom: 12px;
            text-transform: capitalize;
            font-family: "Sabon Next LT Pro";
            font-weight: 500;
        `,
    },
    cardDescription: {
        color: "#333333",
        css: css`
            margin-bottom: 8px;
            text-overflow: ellipsis;
            display: -webkit-box;
            overflow: hidden;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        `,
    },
    cardLink: {
        css: css`
            position: absolute;
            bottom: 15px;
            left: 18px;
        `,
    },
    cardSummary: {
        css: css`
            margin-left: 20px;
        `,
    },

    modalWrapper: {
        css: css`
            display: flex;
        `,
    },
};
const styles = gaiaListingTileStyles;
const GAIAListingTile: React.FC<Props> = ({ fields, currentStepData, history, location }) => {
    const closeModalHandler = () => {
        const newLocation = `${location.pathname}`;
        history.replace(newLocation);
    };
    const openModalHandler = (step: number) => {
        const newLocation = `${location.pathname}?step=${step}`;
        history.replace(newLocation);
    };

    return (
        <>
            <StyledWrapper {...styles.gaiaListingContainer}>
                {fields.links?.map((item, index) => {
                    return (
                        <StyledWrapper key={index} {...styles.cardMainContainer}>
                            <Link {...styles.cardMainWrapper} onClick={() => openModalHandler(index + 1)}>
                                <StyledWrapper {...styles.cardTileImage}>
                                    <Img
                                        src={item.fields.imageUrl}
                                        altText={item.fields.altText}
                                        loading="lazy"
                                        {...styles.img}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.cardContentWrapper}>
                                    <Typography {...styles.cardTitle}>{item.fields.title}</Typography>
                                    <Typography as="p" {...styles.cardDescription}>
                                        {item.fields.description}
                                    </Typography>
                                </StyledWrapper>
                            </Link>
                            <Link
                                {...styles.cardLink}
                                role="link"
                                aria-label={`Read more about ${item.fields.title}`}
                                onClick={() => openModalHandler(index + 1)}
                            >
                                Read More
                            </Link>
                        </StyledWrapper>
                    );
                })}
                {currentStepData && (
                    <Modal
                        isOpen={currentStepData !== null}
                        handleClose={closeModalHandler}
                        {...styles.cardModal}
                        headline={currentStepData.fields.title}
                        tabIndex={-1}
                        role="application"
                    >
                        <GAIATileDetailsModal
                            modalImg={currentStepData.fields.imageUrl}
                            modalSummary={parse(currentStepData.fields.summary, parserOptions)}
                        />
                    </Modal>
                )}
            </StyledWrapper>
        </>
    );
};
const definition: WidgetDefinition = {
    group: "Basic",
    fieldDefinitions: [
        {
            name: fields.links,
            editorTemplate: "ListField",
            defaultValue: [],
            fieldType: "General",
            getDisplay: (item: HasFields) => {
                return item.fields.title;
            },
            fieldDefinitions: [
                {
                    name: "imageUrl",
                    editorTemplate: "ImagePickerField",
                    defaultValue: "",
                },
                {
                    name: "altText",
                    editorTemplate: "TextField",
                    defaultValue: "",
                },

                {
                    name: "title",
                    displayName: "Title",
                    editorTemplate: "TextField",
                    defaultValue: "",
                    tooltip: "text tip",
                    placeholder: "text placeholder",
                    isRequired: true,
                },

                {
                    name: "description",
                    displayName: "Description",
                    editorTemplate: "MultilineTextField",
                    defaultValue: "",
                    tooltip: "multi line tip",
                    placeholder: "multi line placeholder",
                    isRequired: true,
                },
                {
                    name: "summary",
                    displayName: "Summary",
                    editorTemplate: "RichTextField",
                    defaultValue: "",
                },
            ],
        },
    ],
};

const widgetModule: WidgetModule = {
    component: withHistory(connect(mapStateToProps)(GAIAListingTile)),
    definition,
};

export default widgetModule;
